import Ssv from '../Ssv';
import WatchDog from '../WatchDog';

export default {
    path: '/skola-suche-vystavby',
    component: Ssv,
    children: [
        {
            path: 'kurz/:slug',
            name: 'ssv.watchDog',
            component: WatchDog,
        }
    ]
}



// WEBPACK FOOTER //
// ./src/components/ssv/router/index.js